<div class="wa-flank wa-align-items-start">
    <app-survey-list
      [user]="currentUser"
    >
    </app-survey-list>
</div>
